import type { CSSObject } from "tss-react"

export const PRINT_PAGE_ONLY_CLASS = "print-page-only"

export const PRINT_PLAIN_BACKGROUND_CLASS = "print-plain-background"

export const HIDDEN_IN_PRINT: CSSObject = {
    "@media print": {
        display: "none",
    },
}

export const VISIBLE_ONLY_IN_PRINT: CSSObject = {
    display: "none",
    "@media print": {
        display: "block",
        "&&": {
            marginTop: 0,
        },
    },
}

export function whenPrintingPageOnly(styles: CSSObject): CSSObject {
    return {
        "@media print": {
            [`body.${PRINT_PAGE_ONLY_CLASS} &`]: styles,
        },
    }
}

export function whenPrintingPlainBackground(styles: CSSObject): CSSObject {
    return {
        [`body.${PRINT_PLAIN_BACKGROUND_CLASS} &`]: {
            "@media print": styles,
        },
    }
}
